import moment from 'moment-timezone';
import 'moment/locale/fr';
import Vue from 'vue';
import VueMoment from 'vue-moment/vue-moment';

moment.locale(document.documentElement.lang || 'fr');

Vue.use(VueMoment, {
  moment,
});

Vue.filter('momentFromUTC', (value) => moment.utc(value).local());

export default moment;
